import {
  StyledToggleButton,
  StyledToggleButtonGroup,
  StyledOption,
  SortIconWrapper,
} from './CustomSortGroup.styles.ts'
import { ReactNode, MouseEvent } from 'react'
import SortDescIcon from '@/core/assets/icons/sort-desc.svg'
import Tooltip from '@mui/material/Tooltip'

interface Props<T> {
  asc: boolean

  value: T
  options: T[]
  onChange: (value: T) => void
  renderOption?: (option: T) => ReactNode
  optionToString?: (option: T) => string
  getTooltipText?: (option: T) => string
}

function CustomSortGroup<T>({
  value,
  asc,
  options,
  renderOption,
  optionToString = JSON.stringify,
  onChange,
  getTooltipText,
}: Props<T>) {
  const handleChange = (_: MouseEvent<HTMLElement>, stringValue: string) => {
    const newValue = options.find(
      (option) => optionToString(option) === stringValue,
    )

    onChange(newValue ?? value)
  }

  return (
    <StyledToggleButtonGroup
      exclusive
      value={optionToString(value)}
      size="small"
      onChange={handleChange}
    >
      {options.map((option, index) => (
        <Tooltip key={index} title={getTooltipText?.(option)}>
          <StyledToggleButton value={optionToString(option)}>
            {renderOption ? (
              renderOption(option)
            ) : (
              <StyledOption>{optionToString(option)}</StyledOption>
            )}

            {value === option && (
              <SortIconWrapper className={asc ? 'rotate' : ''}>
                <SortDescIcon />
              </SortIconWrapper>
            )}
          </StyledToggleButton>
        </Tooltip>
      ))}
    </StyledToggleButtonGroup>
  )
}

export default CustomSortGroup
